module.exports = __webpack_public_path__ + "img/17_evb-potsdam.cbefe2be.jpg";